export default __webpack_public_path__ + "static/hippo_3dprint-3f7a126f49eaa3a3b3cfc2bf030393d2.jpg";